import { getMappedEnv } from '@atlassian/atlassian-studio-env-utils';

const V2_STUDIO_DOMAIN = 'studio-next.';

let isV2: boolean | undefined;

/**
 * Sets the Studio V2 flag based on workspace context.
 * This should be called by AppSelector after workspace context is gathered.
 *
 * @param value - true if Studio V2, false if Studio V1
 */
export const setIsStudioV2 = (value: boolean): void => {
	isV2 = value;
};

export const isStudioV2 = (): boolean => {
	if (isV2 !== undefined) {
		return isV2;
	}

	isV2 =
		window.location.hostname.startsWith(V2_STUDIO_DOMAIN) ||
		(getMappedEnv() === 'local' && localStorage.getItem('studio-app-v2') === 'true');
	return isV2;
};
